import type { WorkflowDefinition } from '../shared/index.js';

import type { BoardCard, CardPlacement } from '../api/endpoints.js';

const STEP = 1024;

function positionBetween(before: BoardCard | undefined, after: BoardCard | undefined): string {
  const low = before === undefined ? 0 : Number.parseFloat(before.boardPosition);
  const high = after === undefined ? low + STEP * 2 : Number.parseFloat(after.boardPosition);

  return ((low + high) / 2).toFixed(12);
}

export function applyCardMove(
  items: readonly BoardCard[],
  ticketId: string,
  placement: CardPlacement,
  workflow: WorkflowDefinition,
): readonly BoardCard[] {
  const moved = items.find((ticket) => ticket.id === ticketId);
  const stage = workflow.stages.find((entry) => entry.id === placement.stageId);

  if (moved === undefined || stage === undefined) return items;

  const column = items
    .filter((ticket) => ticket.stageId === placement.stageId && ticket.id !== ticketId)
    .sort(
      (left, right) =>
        Number.parseFloat(left.boardPosition) - Number.parseFloat(right.boardPosition),
    );

  let index = column.length;

  if (placement.beforeTicketId !== undefined) {
    const at = column.findIndex((ticket) => ticket.id === placement.beforeTicketId);
    if (at !== -1) index = at;
  } else if (placement.afterTicketId !== undefined) {
    const at = column.findIndex((ticket) => ticket.id === placement.afterTicketId);
    if (at !== -1) index = at + 1;
  }

  const position = positionBetween(column[index - 1], column[index]);

  return items.map((ticket) =>
    ticket.id === ticketId
      ? {
          ...ticket,
          stageId: stage.id,
          stageSlug: stage.slug,
          stageLabel: stage.label,
          boardPosition: position,
        }
      : ticket,
  );
}
